import React, { lazy } from "react";
import Loadable from "components/Loadable";
import MainLayout from "layout/MainLayout";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import { ClaimsProvider } from "contexts/ClaimsContext";
import Approval from "Component/Approval/approval";
import AssignBillingType from "Component/AssignBillingType/AssignBillingType";
// import { Approval } from "@mui/icons-material";

const MISreport = Loadable(lazy(() => import("pages/extra-pages/MISReport/MISreport")));
const NetworkMISReport = Loadable(lazy(() => import("pages/extra-pages/MISReport/NetworkMIS")));
const ExcessFeeSlabs = Loadable(lazy(() => import("pages/extra-pages/Dataupload/ExcessFeeSlabs")));
const PaymentHistory = Loadable(lazy(() => import("pages/extra-pages/gadgetAdmin/PaymentHistory")));
const ResentCustomerFromLink = Loadable(lazy(() => import("pages/extra-pages/GadgetAgent/ResentCustomerFromLink")));
const ResentPaymentLink = Loadable(lazy(() => import("pages/extra-pages/gadgetNetwork/ResentPaymentLink")));
const ExcessFeesByEasybuzz = Loadable(lazy(() => import("pages/extra-pages/gadgetNetwork/ExcessFeesByEasybuzz")));
const InsurerBillingTable = Loadable(lazy(() => import("pages/extra-pages/gadgetNetwork/InsurerBillingTable")));
const InsurerDashboard = Loadable(lazy(() => import("pages/extra-pages/InsurerDashboard/InsurerDashboard")));
const FinanceDashboard = Loadable(lazy(() => import("Component/FinanceDashboard")));
const InsurerUploadSummary = Loadable(lazy(() => import("pages/extra-pages/InsurerUploadSummary/InsurerUploadSummary")));
const FeedbackCalling = Loadable(lazy(() => import("pages/extra-pages/FeedbackCalling/FeedbackCalling")));
const UnlistedClaims = Loadable(lazy(() => import("pages/extra-pages/GadgetAgent/UnlistedClaims")));

const ReviewBatchPage = Loadable(lazy(() => import("Component/Review batches/ReviewBatchPage")));
const Review_batches = Loadable(lazy(() => import("Component/Review batches/review_batches")));
const ApprovalBatchPage = Loadable(lazy(() => import("Component/Approval/ApprovalBatchPage")));
const Vendor_name = Loadable(lazy(() => import("Component/Vandor Name/vendor_name")));
const VendorBatchPage = Loadable(lazy(() => import("Component/Vandor Name/VendorBatchPage")));
const InvoiceTemplate = Loadable(lazy(() => import("Component/InvoiceTemplate/Invoice_template")));
const EditData = Loadable(lazy(() => import("Component/Review batches/EditData")));
const Reajectedcases = Loadable(lazy(() => import("Component/ReajectedCases/Reajectedcases")));
const RejectedCasePage = Loadable(lazy(() => import("Component/ReajectedCases/RejectedCasePage")));
const QueryCases = Loadable(lazy(() => import("Component/Query case/QueryCases")));
const QueryCasePage = Loadable(lazy(() => import("Component/Query case/QuaryCasePage")));
const HoldCases = Loadable(lazy(() => import("Component/Hold Cases/HoldCases")));
const CompletedBatches = Loadable(lazy(() => import("Component/completedBatch/CompletedBatches")));
const HoldCasesPage = Loadable(lazy(() => import("Component/Hold Cases/HoldCasesPage")));
const Concern = Loadable(lazy(() => import("Component/Concern/concern")));
const BankReject = Loadable(lazy(() => import("Component/BankReject/BankReject")));
const PartialApproval = Loadable(lazy(() => import("Component/PartialApproval/PartialApproval")));
const PartialDetailPage = Loadable(lazy(() => import("Component/PartialApproval/PartialDetailPage")));
const SendBackByApproval = Loadable(lazy(() => import("Component/SendBackByApproval/SendBackByApproval")));
const SendbackDetailPage = Loadable(lazy(() => import("Component/SendBackByApproval/SendBackDetailPage")));
const NetworkRejectPage = Loadable(lazy(() => import("Component/getnetworkReject/NetworkRejectPage")));
const ApprovedBatches = Loadable(lazy(() => import("Component/ApprovedBatches/APprovedBatches")));
const ApprovedBatchData = Loadable(lazy(() => import("Component/ApprovedBatches/ApprovedBatchDetails")));
const GlobalSearchResult = Loadable(lazy(() => import("Component/GlobalSearch")));
const LogPage = Loadable(lazy(() => import("Component/LogPage")));
const RemarksLogsPage = Loadable(lazy(() => import("Component/RemarksLogPage")));
const Dashboard = Loadable(lazy(() => import("Component/FinanceDashboard")));
const VendorMIS = Loadable(lazy(() => import("Component/MIS/VendorMIS")));
const InvoiceMIS = Loadable(lazy(() => import("Component/MIS/InvoiceMIS")));
const BatchMIS = Loadable(lazy(() => import("Component/MIS/BatchMIS")));
const PaymentMIS = Loadable(lazy(() => import("Component/MIS/PaymentMIS")));
const VendorInvoices = Loadable(lazy(() => import("Component/MIS/VendorInvoices")));
const OPenCases = Loadable(lazy(() => import("Component/MIS/OPenCases")));


const SalesDataClaimDetails = Loadable(lazy(() => import("pages/extra-pages/GadgetAgent/SalesDataClaimDetails")));
const CriticalUploader = Loadable(lazy(() => import("pages/extra-pages/Dataupload/CriticalUploader")));
const PendingCalimsAndIntimation = Loadable(lazy(() => import("pages/extra-pages/GadgetAgent/PendingCalimsAndIntimation")));
const MissingIntimation = Loadable(lazy(() => import("pages/extra-pages/Dataupload/MissingIntimation")));
const IntimationMISTeacker = Loadable(lazy(() => import("pages/extra-pages/MISReport/IntimationMISTeacker")));
const ETAReminder = Loadable(lazy(() => import("pages/extra-pages/gadgetNetwork/ETAReminder")));
const EscalatedClaimsView = Loadable(lazy(() => import("pages/extra-pages/gadgetNetwork/EscalatedClaimsView")));
const EscalatedFrom = Loadable(lazy(() => import("pages/extra-pages/GadgetAgent/EscalatedFrom")));
const EscalateApproval = Loadable(lazy(() => import("pages/extra-pages/GadgetAgent/EscalateApproval")));
const DownloadPicture = Loadable(lazy(() => import("components/download/DownloadPicture")));
const IntimationApprovalDetails = Loadable(lazy(() => import("pages/extra-pages/GadgetAgent/IntimationApprovalDetails")));
const LogisticsCharges = Loadable(lazy(() => import("pages/extra-pages/Dataupload/LogisticsCharges")));
const DuplicateCalims = Loadable(lazy(() => import("pages/extra-pages/GadgetAgent/DuplicateCalims")));
const DuplicateClaimDetails = Loadable(lazy(() => import("pages/extra-pages/GadgetAgent/DuplicateCalimsDetails")));

const Login = Loadable(lazy(() => import("pages/authentication/Login")));

const AutoagentDash = Loadable(lazy(() => import("pages/extra-pages/Dashboard/dashboard")));
const AllApprovalPhotos = Loadable(lazy(() => import("pages/extra-pages/gadgetNetwork/AllApprovalPhotos")));

const CLaimDetails = Loadable(lazy(() => import("pages/extra-pages/GadgetAgent/ClaimDetails")));
const RegistCases = Loadable(lazy(() => import("pages/extra-pages/GadgetAgent/RegisterCases")));
const GadgetagentApproved = Loadable(lazy(() => import("pages/extra-pages/GadgetAgent/GadgetagentApproved")));
const Preapproval = Loadable(lazy(() => import("pages/extra-pages/GadgetAgent/ResentCustomerFromLink")));
const EstimateApproval = Loadable(lazy(() => import("pages/extra-pages/gadgetNetwork/EstimateApproval")));
const InitiateNewClaim = Loadable(lazy(() => import("pages/extra-pages/GadgetAgent/InitiateNewClaim")));
const RemarkDetailsPage = Loadable(lazy(() => import("pages/extra-pages/GadgetAgent/RemarkDetail")));
const ClaimsingleDetail = Loadable(lazy(() => import("pages/extra-pages/GadgetAgent/ClaimsingleDetail")));
const AgentMISReport = Loadable(lazy(() => import("pages/extra-pages/MISReport/AgentMIS")));

const ApporvalCases = Loadable(lazy(() => import("pages/extra-pages/gadgetNetwork/ApporvalCases")));
const MobilesalesUpload = Loadable(lazy(() => import("pages/extra-pages/gadgetNetwork/MobilesalesUpload")));
const ProductBulkupload = Loadable(lazy(() => import("pages/extra-pages/gadgetNetwork/ProductBulkupload")));
const RegisteredCases = Loadable(lazy(() => import("pages/extra-pages/gadgetNetwork/InitiatedCases")));
const ServiceProvider = Loadable(lazy(() => import("pages/extra-pages/gadgetNetwork/ServiceProvider")));
const CaseReopen = Loadable(lazy(() => import("pages/extra-pages/gadgetNetwork/CaseReopen")));
const EscalationClaims = Loadable(lazy(() => import("pages/extra-pages/gadgetNetwork/EscalationClaims")));
const ApprovesparePart = Loadable(lazy(() => import("pages/extra-pages/gadgetNetwork/ApprovesparePart")));
const ExcessFees = Loadable(lazy(() => import("pages/extra-pages/gadgetNetwork/ExcessFees")));
const RepairApprovalPending = Loadable(lazy(() => import("pages/extra-pages/gadgetNetwork/RepairApprovalPending")));
const ApprovalRepair = Loadable(lazy(() => import("pages/extra-pages/gadgetNetwork/ApprovalRepair")));
const CancellationApproval = Loadable(lazy(() => import("pages/extra-pages/gadgetNetwork/CancellationApproval")));
const ReopenCasedeail = Loadable(lazy(() => import("pages/extra-pages/gadgetNetwork/ReopenCasedeail")));
const BERsettlement = Loadable(lazy(() => import("pages/extra-pages/gadgetNetwork/BERsettlement")));
const BERFOrm = Loadable(lazy(() => import("pages/extra-pages/gadgetNetwork/BERFOrm")));
const AddBankDetails = Loadable(lazy(() => import("pages/extra-pages/gadgetNetwork/AddBankDetails")));
const SparePartDetails = Loadable(lazy(() => import("pages/extra-pages/gadgetNetwork/SparePartDetails")));
const ReAssignedToVendor = Loadable(lazy(() => import("pages/extra-pages/gadgetNetwork/ReAssignedToVendor")));

const CreategadgetUser = Loadable(lazy(() => import("pages/extra-pages/gadgetAdmin/userCreation")));
const UpdateGadgetUser = Loadable(lazy(() => import("pages/extra-pages/gadgetAdmin/UpdateGadgetUser")));

const BulkUpload = Loadable(lazy(() => import("pages/extra-pages/Dataupload/BulkUpload")));
const FloatUpload = Loadable(lazy(() => import("pages/extra-pages/Dataupload/FloatUpload")));
const Productupload = Loadable(lazy(() => import("pages/extra-pages/Dataupload/Productupload")));
const CityUpload = Loadable(lazy(() => import("pages/extra-pages/Dataupload/CityUpload")));
const BrandUpload = Loadable(lazy(() => import("pages/extra-pages/Dataupload/BrandUpload")));
const DefectUpload = Loadable(lazy(() => import("pages/extra-pages/Dataupload/DefectUpload")));
const ServicePartnerupload = Loadable(lazy(() => import("pages/extra-pages/Dataupload/ServicePartnerupload")));
const Insurerupload = Loadable(lazy(() => import("pages/extra-pages/Dataupload/Insurerupload")));
const ClientUpload = Loadable(lazy(() => import("pages/extra-pages/Dataupload/ClientUpload")));
const CancellationUpload = Loadable(lazy(() => import("pages/extra-pages/Dataupload/CancellationUpload")));
const RejectionUpload = Loadable(lazy(() => import("pages/extra-pages/Dataupload/RejectionUpload")));
const PLanUpload = Loadable(lazy(() => import("pages/extra-pages/Dataupload/PLanUpload")));
const PlanWiseBERSlabsUpload = Loadable(lazy(() => import("pages/extra-pages/Dataupload/PlanWiseBERSlabsUpload")));
const UpdateBERSlabs = Loadable(lazy(() => import("pages/extra-pages/Dataupload/UpdateBERSlabs")));
const UpdatePlansBenefits = Loadable(lazy(() => import("pages/extra-pages/Dataupload/UpdatePlansBenefits")));

const AssignRole = Loadable(lazy(() => import("pages/extra-pages/userCreation/AssignRole")));
const CreateUser = Loadable(lazy(() => import("pages/extra-pages/userCreation/createUser")));

const PolicyCancellation = Loadable(lazy(() => import("pages/extra-pages/policyManagement/policyCancellation")));
const PolicyDownload = Loadable(lazy(() => import("pages/extra-pages/policyManagement/policyDownload")));
const PolicyIssuance = Loadable(lazy(() => import("pages/extra-pages/policyManagement/policyIssuance")));

const PageNotFound = Loadable(lazy(() => import("pages/extra-pages/PageNotFound/PageNotFound")));


const MainRoutes = {
  path: "/",
  element: (
    <ClaimsProvider>
      <MainLayout />
    </ClaimsProvider>
  ),
  children: [
    {
      path: "/",
      element: (
        <PublicRoute>
          <Login />
        </PublicRoute>
      ),
    },
    {
      path: "dashboard",
      element: (
        <PrivateRoute>
          <AutoagentDash />
        </PrivateRoute>
      ),
    },
    {
      path: "insurer_dashboard",
      element: (
        <PrivateRoute>
          <InsurerDashboard />
        </PrivateRoute>
      ),
    },
    {
      path: "finance_dashboard",
      element: (
        <PrivateRoute>
          <FinanceDashboard />
        </PrivateRoute>
      ),
    },
    {
      path: "create-user",
      element: (
        <PrivateRoute>
          <CreateUser />
        </PrivateRoute>
      ),
    },
    {
      path: "assign-role",
      element: (
        <PrivateRoute>
          <AssignRole />
        </PrivateRoute>
      ),
    },
    {
      path: "MIS-REPORT",
      element: (
        <PrivateRoute>
          <MISreport />
        </PrivateRoute>
      ),
    },
    {
      path: "network-MIS-report",
      element: (
        <PrivateRoute>
          <NetworkMISReport />
        </PrivateRoute>
      ),
    },
    {
      path: "agent-MIS-report",
      element: (
        <PrivateRoute>
          <AgentMISReport />
        </PrivateRoute>
      ),
    },
    {
      path: "Intimation-MIS-Tracker",
      element: (
        <PrivateRoute>
          <IntimationMISTeacker />
        </PrivateRoute>
      ),
    },
    {
      path: "payment_history",
      element: (
        <PrivateRoute>
          <PaymentHistory />
        </PrivateRoute>
      ),
    },
    {
      path: "insurer_billing",
      element: (
        <PrivateRoute>
          <InsurerBillingTable />
        </PrivateRoute>
      ),
    },
    {
      path: "policy-certificate-issuance",
      element: (
        <PrivateRoute>
          <PolicyIssuance />
        </PrivateRoute>
      ),
    },
    {
      path: "policy-certificate-download",
      element: (
        <PrivateRoute>
          <PolicyDownload />
        </PrivateRoute>
      ),
    },
    {
      path: "policy-certificate-cancellation",
      element: (
        <PrivateRoute>
          <PolicyCancellation />
        </PrivateRoute>
      ),
    },
    {
      path: "Product-upload",
      element: (
        <PrivateRoute>
          <Productupload />
        </PrivateRoute>
      ),
    },
    {
      path: "Float-amount-upload",
      element: (
        <PrivateRoute>
          <FloatUpload />
        </PrivateRoute>
      ),
    },
    {
      path: "Bulk-Updates&Miscellaneous",
      element: (
        <PrivateRoute>
          <BulkUpload />
        </PrivateRoute>
      ),
    },
    {
      path: "Mobile-Sales-Upload",
      element: (
        <PrivateRoute>
          <MobilesalesUpload />
        </PrivateRoute>
      ),
    },
    {
      path: "Product-Bulk-Upload",
      element: (
        <PrivateRoute>
          <ProductBulkupload />
        </PrivateRoute>
      ),
    },
    {
      path: "UploadCity",
      element: (
        <PrivateRoute>
          <CityUpload />
        </PrivateRoute>
      ),
    },
    {
      path: "UploadBrand",
      element: (
        <PrivateRoute>
          <BrandUpload />
        </PrivateRoute>
      ),
    },
    {
      path: "UploadDefect",
      element: (
        <PrivateRoute>
          <DefectUpload />
        </PrivateRoute>
      ),
    },
    {
      path: "UploadServicePartner",
      element: (
        <PrivateRoute>
          <ServicePartnerupload />
        </PrivateRoute>
      ),
    },
    {
      path: "UploadInsurer",
      element: (
        <PrivateRoute>
          <Insurerupload />
        </PrivateRoute>
      ),
    },
    {
      path: "UploadClient",
      element: (
        <PrivateRoute>
          <ClientUpload />
        </PrivateRoute>
      ),
    },
    {
      path: "planWiseBerSlabs",
      element: (
        <PrivateRoute>
          <PlanWiseBERSlabsUpload />
        </PrivateRoute>
      ),
    },
    {
      path: "excessFeesCalAmountSlabs",
      element: (
        <PrivateRoute>
          <ExcessFeeSlabs />
        </PrivateRoute>
      ),
    },
    {
      path: "updateBerSlabs/:rowId",
      element: (
        <PrivateRoute>
          <UpdateBERSlabs />
        </PrivateRoute>
      ),
    },
    {
      path: "UploadCancellationReason",
      element: (
        <PrivateRoute>
          <CancellationUpload />
        </PrivateRoute>
      ),
    },
    {
      path: "UploadRejectionReason",
      element: (
        <PrivateRoute>
          <RejectionUpload />
        </PrivateRoute>
      ),
    },
    {
      path: "All-registered-Cases",
      element: (
        <PrivateRoute>
          <RegistCases />
        </PrivateRoute>
      ),
    },
    {
      path: "/duplicate_calims",
      element: (
        <PrivateRoute>
          <DuplicateCalims />
        </PrivateRoute>
      ),
    },
    {
      path: "/unlisted_Clients_calims",
      element: (
        <PrivateRoute>
          <UnlistedClaims />
        </PrivateRoute>
      ),
    },
    {
      path: "Duplicate-Claim-Details/:aA_Number",
      element: (
        <PrivateRoute>
          <DuplicateClaimDetails />
        </PrivateRoute>
      ),
    },
    {
      path: "pending-claims/:aA_Number",
      element: (
        <PrivateRoute>
          <PendingCalimsAndIntimation />
        </PrivateRoute>
      ),
    },
    {
      path: "pending-intimation/:aA_Number",
      element: (
        <PrivateRoute>
          <PendingCalimsAndIntimation />
        </PrivateRoute>
      ),
    },
    {
      path: "approvalPhoto/:aA_Number",
      element: (
        <PrivateRoute>
          <AllApprovalPhotos />
        </PrivateRoute>
      ),
    },
    {
      path: "all-initiated-cases",
      element: (
        <PrivateRoute>
          <RegisteredCases />
        </PrivateRoute>
      ),
    },
    {
      path: "Approved-Cases",
      element: (
        <PrivateRoute>
          <ApporvalCases />
        </PrivateRoute>
      ),
    },
    {
      path: "Reassigned-Vendor",
      element: (
        <PrivateRoute>
          <ReAssignedToVendor />
        </PrivateRoute>
      ),
    },
    {

      path: "Initiate-Claim",
      element: (
        <PrivateRoute>
          <CLaimDetails />
        </PrivateRoute>
      ),
    },
    {
      path: "Initiate-Sales-Claim/:IMEI_Number",
      element: (
        <PrivateRoute>
          <SalesDataClaimDetails />
        </PrivateRoute>
      ),
    },
    {
      path: "initiate-new-claim",
      element: (
        <PrivateRoute>
          <InitiateNewClaim />
        </PrivateRoute>
      ),
    },
    {
      path: "/claimDetails/:aA_Number",
      element: (
        <PrivateRoute>
          <ClaimsingleDetail />
        </PrivateRoute>
      ),
    },
    {
      path: "remarks/:aANumber",
      element: (
        <PrivateRoute>
          <RemarkDetailsPage />
        </PrivateRoute>
      ),
    },
    {
      path: "Estimate-Approval",
      element: (
        <PrivateRoute>
          <EstimateApproval />
        </PrivateRoute>
      ),
    },
    {
      path: "Intimation-Approval",
      element: (
        <PrivateRoute>
          <GadgetagentApproved />
        </PrivateRoute>
      ),
    },
    {
      path: "Intimation-Approval-Details/:aA_Number",
      element: (
        <PrivateRoute>
          <IntimationApprovalDetails />
        </PrivateRoute>
      ),
    },
    {
      path: "/Customer_Form",
      element: (
        <PrivateRoute>
          <ResentCustomerFromLink />
        </PrivateRoute>
      ),
    },
    {
      path: "/Payment_Link",
      element: (
        <PrivateRoute>
          <ResentPaymentLink />
        </PrivateRoute>
      ),
    },
    {
      path: "repairApproval",
      element: (
        <PrivateRoute>
          <RepairApprovalPending />
        </PrivateRoute>
      ),
    },
    {
      path: "approveRepair/:aA_Number",
      element: (
        <PrivateRoute>
          <ApprovalRepair />
        </PrivateRoute>
      ),
    },
    {
      path: 'sparePartDetails/:aA_Number',
      element: (
        <PrivateRoute>
          <SparePartDetails />
        </PrivateRoute>
      )
    },
    {
      path: "approveSparePart/:aA_Number",
      element: (
        <PrivateRoute>
          <ApprovesparePart />
        </PrivateRoute>
      ),
    },
    {
      path: "feedbackCalling",
      element: (
        <PrivateRoute>
          <FeedbackCalling />
        </PrivateRoute>
      ),
    },
    {
      path: "insurerUploadSummary",
      element: (
        <PrivateRoute>
          <InsurerUploadSummary />
        </PrivateRoute>
      ),
    },
    {
      path: "BER-Settlement",
      element: (
        <PrivateRoute>
          <BERsettlement />
        </PrivateRoute>
      ),
    },
    {
      path: "BER-form",
      element: (
        <PrivateRoute>
          <BERFOrm />
        </PrivateRoute>
      ),
    },
    {
      path: "add-bank-details/:aA_Number",
      element: (
        <PrivateRoute>
          <AddBankDetails />
        </PrivateRoute>
      ),
    },
    {
      path: "cancellation-approval",
      element: (
        <PrivateRoute>
          <CancellationApproval />
        </PrivateRoute>
      ),
    },
    {
      path: "case-Reopen",
      element: (
        <PrivateRoute>
          <ReopenCasedeail />
        </PrivateRoute>
      ),
    },
    {
      path: "ReopenCases",
      element: (
        <PrivateRoute>
          <CaseReopen />
        </PrivateRoute>
      ),
    },
    {
      path: "/eTAReminder",
      element: (
        <PrivateRoute>
          <ETAReminder />
        </PrivateRoute>
      ),
    },
    {
      path: "Escalations",
      element: (
        <PrivateRoute>
          <EscalationClaims />
        </PrivateRoute>
      ),
    },
    {
      path: "/Escalations_Approval",
      element: (
        <PrivateRoute>
          <EscalateApproval />
        </PrivateRoute>
      ),
    },
    {
      path: "/ReviewBatchPage",
      element: (
        <PrivateRoute>
          <ReviewBatchPage />
        </PrivateRoute>
      ),
    },
    {
      path: "/invoice",
      element: (
        <PrivateRoute>
          <Review_batches />
        </PrivateRoute>
      ),
    },
    {
      path: "/Assign_Billing_Type",
      element: (
        <PrivateRoute>
          <AssignBillingType />
        </PrivateRoute>
      ),
    },
    {
      path: "/approval",
      element: (
        <PrivateRoute>
          <Approval />
        </PrivateRoute>
      ),
    },
    {
      path: "/approvalBatchPage",
      element: (
        <PrivateRoute>
          <ApprovalBatchPage />
        </PrivateRoute>
      ),
    },
    {
      path: "/vendor-name",
      element: (
        <PrivateRoute>
          <Vendor_name />
        </PrivateRoute>
      ),
    },
    {
      path: "/vendorBatchPage",
      element: (
        <PrivateRoute>
          <VendorBatchPage />
        </PrivateRoute>
      ),
    },
    {
      path: "/invoice-template",
      element: (
        <PrivateRoute>
          <InvoiceTemplate />
        </PrivateRoute>
      ),
    },
    {
      path: "/Edit-data",
      element: (
        <PrivateRoute>
          <EditData />
        </PrivateRoute>
      ),
    },
    {
      path: "/rejected-cases",
      element: (
        <PrivateRoute>
          <Reajectedcases />
        </PrivateRoute>
      ),
    },
    {
      path: "/reajectedcasesPage",
      element: (
        <PrivateRoute>
          <RejectedCasePage />
        </PrivateRoute>
      ),
    },
    {
      path: "/query-case",
      element: (
        <PrivateRoute>
          <QueryCases />
        </PrivateRoute>
      ),
    },
    {
      path: "/queryCasesPage",
      element: (
        <PrivateRoute>
          <QueryCasePage />
        </PrivateRoute>
      ),
    },
    {
      path: "/hold-case",
      element: (
        <PrivateRoute>
          <HoldCases />
        </PrivateRoute>
      ),
    },
    {
      path: "/completed-batches",
      element: (
        <PrivateRoute>
          <CompletedBatches />
        </PrivateRoute>
      ),
    },
    {
      path: "/holdCasesPage",
      element: (
        <PrivateRoute>
          <HoldCasesPage />
        </PrivateRoute>
      ),
    },
    {
      path: "/concern",
      element: (
        <PrivateRoute>
          <Concern />
        </PrivateRoute>
      ),
    },
    {
      path: "/bankReject",
      element: (
        <PrivateRoute>
          <BankReject />
        </PrivateRoute>
      ),
    },
    {
      path: "/partialApproval",
      element: (
        <PrivateRoute>
          <PartialApproval />
        </PrivateRoute>
      ),
    },
    {
      path: "/partialDetailPage",
      element: (
        <PrivateRoute>
          <PartialDetailPage />
        </PrivateRoute>
      ),
    },
    {
      path: "/sendBackByapproval",
      element: (
        <PrivateRoute>
          <SendBackByApproval />
        </PrivateRoute>
      ),
    },
    {
      path: "/sendBackdetailPage",
      element: (
        <PrivateRoute>
          <SendbackDetailPage />
        </PrivateRoute>
      ),
    },
    {
      path: "/networkRejectedCases",
      element: (
        <PrivateRoute>
          {/* <SendbackDetailPage /> */}
        </PrivateRoute>
      ),
    },
    {
      path: "/networkRejectPage",
      element: (
        <PrivateRoute>
          <NetworkRejectPage />
        </PrivateRoute>
      ),
    },
    {
      path: "/ApprovedBatches",
      element: (
        <PrivateRoute>
          <ApprovedBatches />
        </PrivateRoute>
      ),
    },
    {
      path: "/ApprovedBatchData",
      element: (
        <PrivateRoute>
          <ApprovedBatchData />
        </PrivateRoute>
      ),
    },
    {
      path: "/global-search-result",
      element: (
        <PrivateRoute>
          <GlobalSearchResult />
        </PrivateRoute>
      ),
    },
    {
      path: "/logs/:batchNo",
      element: (
        <PrivateRoute>
          <LogPage />
        </PrivateRoute>
      ),
    },
    {
      path: "/Remarks&Logs/:aa_numbe",
      element: (
        <PrivateRoute>
          <RemarksLogsPage />
        </PrivateRoute>
      ),
    },
    {
      path: "/Fin_Dashboard",
      element: (
        <PrivateRoute>
          <Dashboard />
        </PrivateRoute>
      ),
    },
    {
      path: "/pendingPaymentMIS",
      element: (
        <PrivateRoute>
          <VendorMIS />
        </PrivateRoute>
      ),
    },
    {
      path: "/paidPaymentMIS",
      element: (
        <PrivateRoute>
          <InvoiceMIS />
        </PrivateRoute>
      ),
    },
    {
      path: "/UTRpaymentMIS",
      element: (
        <PrivateRoute>
          <BatchMIS />
        </PrivateRoute>
      ),
    },
    {
      path: "/rawdataMIS",
      element: (
        <PrivateRoute>
          <PaymentMIS />
        </PrivateRoute>
      ),
    },
    {
      path: "/vendor-invoices/:vendorName",
      element: (
        <PrivateRoute>
          <VendorInvoices />
        </PrivateRoute>
      ),
    },
    {
      path: "/UnbilledCases",
      element: (
        <PrivateRoute>
          <OPenCases />
        </PrivateRoute>
      ),
    },
    {
      path: "addEscalationDetails/:aA_Number",
      element: (
        <PrivateRoute>
          <EscalatedFrom />
        </PrivateRoute>
      ),
    },
    {
      path: "EscalatedClaimsView/:aA_Number",
      element: (
        <PrivateRoute>
          <EscalatedClaimsView />
        </PrivateRoute>
      ),
    },
    {
      path: "Excessfees",
      element: (
        <PrivateRoute>
          <ExcessFees />
        </PrivateRoute>
      ),
    },
    {
      path: 'excessFeesbyEasybuzz',
      element: (
        <PrivateRoute>
          <ExcessFeesByEasybuzz />
        </PrivateRoute>
      ),
    },
    {
      path: "service-provider",
      element: (
        <PrivateRoute>
          <ServiceProvider />
        </PrivateRoute>
      ),
    },
    {
      path: "create-gadget-user",
      element: (
        <PrivateRoute>
          <CreategadgetUser />
        </PrivateRoute>
      ),
    },
    {
      path: "update-gadget-user/:userId",
      element: (
        <PrivateRoute>
          <UpdateGadgetUser />
        </PrivateRoute>
      ),
    },
    {
      path: "plans-benefits",
      element: (
        <PrivateRoute>
          <PLanUpload />
        </PrivateRoute>
      ),
    },
    {
      path: "/critical-uploader",
      element: (
        <PrivateRoute>
          <CriticalUploader />
        </PrivateRoute>
      ),
    },
    {
      path: "/missing-intimation-Uploader",
      element: (
        <PrivateRoute>
          <MissingIntimation />
        </PrivateRoute>
      ),
    },
    {
      path: "/logistics-repair-uploader",
      element: (
        <PrivateRoute>
          <LogisticsCharges />
        </PrivateRoute>
      ),
    },
    {
      path: "update-plans-benefits/:userId",
      element: (
        <PrivateRoute>
          <UpdatePlansBenefits />
        </PrivateRoute>
      ),
    },
    {
      path: "Download_Batch_Picture",
      element: (
        <PrivateRoute>
          <DownloadPicture />
        </PrivateRoute>
      ),
    },
    {
      path: "*",
      element: (
        <PrivateRoute>
          <PageNotFound />
        </PrivateRoute>
      ),
    },
  ],
};

export default MainRoutes;
